// The app version shown on the login screen and at the bottom of the sidebar.
// Set it in .env as NEXT_PUBLIC_APP_VERSION=1.0.0 (a leading "v" is fine either way).
// Next.js bakes NEXT_PUBLIC_* values in at build time, so restart `npm run dev` / rebuild after changing it.
// Returns an empty string when it isn't set, so nothing is shown rather than a blank "v".
export function getAppVersionLabel(): string {
  const raw = (process.env.NEXT_PUBLIC_APP_VERSION || '').trim();
  if (!raw) return '';
  return raw.toLowerCase().startsWith('v') ? raw : `v${raw}`;
}
